import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="relative py-28 md:py-36 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Bright%20modern%20fulfillment%20center%20interior%20with%20organized%20shelving%20units%20filled%20with%20neatly%20packaged%20fashion%20parcels%20in%20kraft%20boxes%20warm%20overhead%20LED%20lighting%20conveyor%20belt%20system%20in%20background%20clean%20industrial%20aesthetic%20with%20earthy%20branding%20accents%20spacious%20and%20efficient%20atmosphere%20editorial%20commercial%20photography&width=1800&height=900&seq=cta-bg-fulfillment-v2&orientation=landscape"
          alt="Superbuy Spreadsheet - Start exploring organized product resources and fulfillment center"
          title="Explore Superbuy Spreadsheet Today"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-black/45"></div>

      <div className="relative z-10 max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-10">
          <div className="max-w-[500px]">
            <h2 className="font-heading text-4xl md:text-6xl font-semibold text-background-50 leading-[1.15] mb-6">
              Start Exploring Superbuy Spreadsheet Resources Today
            </h2>
          </div>
          <div className="flex flex-col gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-between gap-4 px-6 py-4 bg-background-50 text-foreground-950 text-sm font-semibold rounded-full hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer group"
            >
              <span>Visit Main Website</span>
              <div className="w-8 h-8 rounded-full bg-foreground-950 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                <i className="ri-arrow-right-line text-background-50 text-sm"></i>
              </div>
            </a>
            <p className="text-background-50/70 text-sm max-w-[240px] leading-relaxed">
              Access the full shopping experience with detailed product information and purchasing options
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}